import React, { useEffect, useState } from 'react';
import { IoMdArrowBack } from "react-icons/io";
import { useNavigate } from 'react-router-dom';
import greencircle from '../../../assets/Images/green circle.png';
import { FaCaretDown } from "react-icons/fa";
import './CampaignPage.scss'
import { PiUserListFill } from "react-icons/pi";
import { IoIosArrowDown } from "react-icons/io";
import { LineChart, Line, XAxis, YAxis, Tooltip, CartesianGrid, Legend, ResponsiveContainer } from "recharts";
import Swal from 'sweetalert2'
import { useParams } from 'react-router-dom';
import darkcircle from '../../../assets/Images/darkcircle.png'
import { useRef } from 'react';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable'; 
import html2canvas from "html2canvas";



function CampaignPage() {
  const baseURL =
    process.env.NODE_ENV === 'production'
      ? process.env.REACT_APP_API_URL_PROD
      : process.env.REACT_APP_API_URL_LOCAL;

const { campaignId } = useParams();
    const navigate = useNavigate("");
    const [campaigns, setCampaigns] = useState("")
     const [showDropdown, setShowDropdown] = useState(false);
      const openModal = () => setIsOpen(true);
       const [isOpen, setIsOpen] = useState(false);
        const dropdownRef = useRef(null);
         const exportRef = useRef();
         const chartRef = useRef();
         const [showSentDetails, setShowSentDetails] = useState(false);
const [expandedEmails, setExpandedEmails] = useState({});
const [activeTab, setActiveTab] = useState(''); 
const [chartData, setChartData] = useState([]);
 

const handleSentTabClick = () => {
  setShowSentDetails(true); 
};

const toggleShowDetails = (email) => {
  setExpandedEmails((prev) => ({
    ...prev,
    [email]: !prev[email],
  }));
};

const handleTabClick = (tab) => {
  setActiveTab(prev => (prev === tab ? '' : tab)); 
};


useEffect(() => {
  const fetchPerformanceData = async () => {
    const token = localStorage.getItem("token");
    try {
      const res = await fetch(`${baseURL}/api/campaign-performance`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const result = await res.json();
      setChartData(result);
    } catch (error) {
      console.error("Error fetching chart data:", error);
    }
  };

  fetchPerformanceData();
}, []);

   

useEffect(() => {
  const fetchCampaigns = async () => {
    const token = localStorage.getItem('token')
    try {
      const response = await fetch(`${baseURL}/api/create-campaign`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const result = await response.json();
      if (!response.ok) {
        throw new Error(result.message || "Failed to fetch campaigns");
      }

      const sortedCampaigns = result.sort(
        (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
      );
      const singleCampaign = sortedCampaigns.find(c => c.campaignId === campaignId);
      setCampaigns(singleCampaign);

    } catch (err) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Something went wrong!',
        confirmButtonColor: 'red',
      });
    }
  };

  fetchCampaigns();
}, [campaignId]);

 const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  useEffect(() => {
      const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
          setShowDropdown(false);
        }
      };
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, []);


const handleExportAsPDF = () => {

  const doc = new jsPDF();

  // Campaign Name as Title
  doc.setFontSize(18);
  doc.text(`${campaigns.campaignName || 'Campaign Report'}`, 14, 20);

  // Status and Created Date
  doc.setFontSize(12);
  const status = campaigns.status === 'sent' ? 'Sent' : 'Draft';
  const createdOn = campaigns.createdAt
    ? new Date(campaigns.createdAt).toLocaleString()
    : 'N/A';
  doc.text(`Status: ${status}`, 14, 30);
  doc.text(`Created On: ${createdOn}`, 14, 38);

  // Summary Report Table
  const summaryColumns = ["Metric", "Count"];
  const summaryRows = [
    ["Total Mails", campaigns.totalRecipients || campaigns.recipientList?.length || 0],
    ["Delivered", (campaigns.totalRecipients || 0) - (campaigns.bouncedEmails?.length || 0)],
    ["Opened", campaigns.openedEmails?.length || 0],
    ["Clicked", campaigns.clickedEmails?.length || 0],
    ["Bounced", campaigns.bouncedEmails?.length || 0],
  ];

  autoTable(doc, {
    startY: 45,
    head: [summaryColumns],
    body: summaryRows,
  });

  // Campaign Details
  let yPosition = doc.previousAutoTable.finalY + 10;

  doc.text("Details:", 14, yPosition);
  yPosition += 6;

  const details = [
    ["Subject", campaigns.subject || "N/A"],
    ["From Address", campaigns.fromEmail || "N/A"],
    ["Recipient List", "List"], // static, you can expand if needed
    ["Last Edited", "Jun 12, 2025 11 AM"], // static, replace with real value if you have
  ];

  details.forEach(([key, value]) => {
    doc.setFont("helvetica", "bold");
    doc.text(`${key}:`, 14, yPosition);
    doc.setFont("helvetica", "normal");
    doc.text(`${value}`, 50, yPosition);
    yPosition += 8;
  });

  // Email Preview
  doc.setFont("helvetica", "bold");
  doc.text(`Email Preview:`, 14, yPosition);
  yPosition += 6;

  doc.setFont("helvetica", "bold");
  doc.text(`Subject:`, 14, yPosition);
  doc.setFont("helvetica", "normal");
  doc.text(`${campaigns.subject || 'N/A'}`, 35, yPosition);
  yPosition += 6;

  doc.setFont("helvetica", "bold");
  doc.text(`Content:`, 14, yPosition);
  doc.setFont("helvetica", "normal");
  const content = campaigns.message || "N/A";
  const splitContent = doc.splitTextToSize(content, 180);
  doc.text(splitContent, 35, yPosition);

  // Save PDF
  doc.save(`${campaigns.campaignName || 'campaign'}-details.pdf`);
};

const handleExportCSV = () => {
  const rows = [
    ["Total mails", campaigns?.totalRecipients || campaigns?.recipientList?.length || 0],
    ["Delivered", campaigns?.totalRecipients - (campaigns?.bouncedEmails?.length || 0)],
    ["Opened", campaigns?.openedEmails?.length || 0],
    ["Clicked", campaigns?.clickedEmails?.length || 0],
    ["Bounced", campaigns?.bouncedEmails?.length || 0],
    ["Subject", campaigns?.subject],
    ["From", campaigns?.fromEmail],
    ["Created On", campaigns?.createdAt ? new Date(campaigns.createdAt).toLocaleString() : "N/A"],
  ];

  let csvContent = "data:text/csv;charset=utf-8,"
    + rows.map(e => e.join(",")).join("\n");

  const encodedUri = encodeURI(csvContent);
  const link = document.createElement("a");
  link.setAttribute("href", encodedUri);
  link.setAttribute("download", "campaign_report.csv");
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const handleDownloadChart = () => {
    if (chartRef.current) {
      html2canvas(chartRef.current).then((canvas) => {
        const link = document.createElement("a");
        link.download = "chart.png";
        link.href = canvas.toDataURL("image/png");
        link.click();
      });
    }
  };

  return (
    <div className='email-form-container'>
      <div ref={exportRef}>
      <div className='campaignname-export' >
        <div>
      <div style={{display:"flex", flexDirection:"row"}}>
             <IoMdArrowBack
                      style={{ fontSize: "25px", cursor: "pointer" }}
                      onClick={() => navigate("/allmail", { state: { selectedTab: 'All Campaign' } })}
                    /> <div className="all-mails" style={{fontSize:"20px"}} >{campaigns?.campaignName}</div>
                </div>
                <div className='sent-status'> 
  <div>
    {campaigns?.status === 'sent' ? (
      <img src={greencircle} alt="sent" width="10px" />
    ) : (
      <img src={darkcircle} alt="draft" width="10px" />
    )}
  </div>
  <div className='sent-date'>
    {campaigns?.status === 'sent'
      ? `Sent | Created on ${
        campaigns?.createdAt
          ? new Date(campaigns.createdAt).toLocaleString('en-US', {
              month: 'short',   
              day: 'numeric',   
              hour: 'numeric',  
              minute: '2-digit', 
              hour12: true      
            })
          : 'N/A'
      }`
      : `Draft | Created on ${campaigns?.createdAt ? new Date(campaigns.createdAt).toLocaleString() : 'N/A'}`}
  </div>
</div>

                </div>
                <div className='campaign-btns' ref={dropdownRef}>
                <div   >
                  <button className='export-btn' onClick={toggleDropdown}>Export <FaCaretDown /></button>
                </div>
                  {showDropdown && (
        <div
          className="dropdown-menu"
          style={{
            position: "absolute",
            top: "23%", 
            left:"80%",
            right: "0",
            background: "#fff",
            width:"200px",
            border: "1px solid #ddd",
            borderRadius: "4px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            zIndex: "1000",
          }}
        >
          <div style={{ margin: 0, padding: "10px 0" }}>
            <div style={{ padding: "8px 20px", cursor: "pointer", fontSize:"15px", fontWeight:"500" }}
             onClick={handleExportAsPDF}>Export as PDF</div>
            <div style={{ padding: "8px 20px", cursor: "pointer" , fontSize:"15px", fontWeight:"500"}} onClick={handleExportCSV}>Export as CSV</div>
            <div style={{ padding: "8px 20px", cursor: "pointer", fontSize:"15px", fontWeight:"500" }} onClick={handleDownloadChart}>Export Chart as PNG</div>
          </div>
        </div>
      )}
                 <div>
                  <button className='more-btn'>More <FaCaretDown /></button>
                </div>
                </div>
                </div>
                <div className='summary'> Summary Report </div>
                <div className='report-container' >
                  <div className={`count-container ${activeTab === 'sent' ? 'email-active-tab' : ''}`} onClick={() => handleTabClick('sent')}>
                    <div className='count-text'>Sent</div>
                  <div className='count-num'>{campaigns?.totalRecipients || campaigns?.recipientList?.length || 0}</div>
                  </div>
                  <div className={`count-container ${activeTab === 'delivered' ? 'email-active-tab' : ''}`} onClick={() => handleTabClick('delivered')}>
                    <div className='count-text'>Delivered</div>
                     <div className='count-num'> {campaigns?.totalRecipients - (campaigns?.bouncedEmails?.length || 0)}</div>
                  </div>
                  <div className={`count-container ${activeTab === 'opened' ? 'email-active-tab' : ''}`} onClick={() => handleTabClick('opened')}>
                    <div className='count-text'>Opened</div>
                     <div className='count-num'> {campaigns?.openedEmails?.length || 0}</div>
                  </div>
                  <div className={`count-container ${activeTab === 'clicked' ? 'email-active-tab' : ''}`} onClick={() => handleTabClick('clicked')}>
                    <div className='count-text'>Clicked</div>
                     <div className='count-num'>{campaigns?.clickedEmails?.length || 0}</div>
                  </div>
                  <div className={`count-container ${activeTab === 'bounced' ? 'email-active-tab' : ''}`} onClick={() => handleTabClick('bounced')}>
                    <div className='count-text'>Bounced</div>
                     <div className='count-num'> {campaigns?.bouncedEmails?.length || 0}</div>
                  </div>
                  <div className={`count-container ${activeTab === 'unsubscribed' ? 'email-active-tab' : ''}`} onClick={() => handleTabClick('unsubscribed')}>
  <div className='count-text'>Unsubscribed</div>
  <div className='count-num'>{campaigns?.unsubscribedEmails?.length || 0}</div>
</div>
                </div>
                {['sent', 'delivered', 'opened', 'clicked', 'bounced', 'unsubscribed'].includes(activeTab) ? (
  <div className="sent-summary">

    <div className="recipients-table">
  <div className="recipients-header">
    <div>Recipients</div>
    <div>Actions</div>
    <div>Date & Time</div>
  </div>
{campaigns?.recipientList
  ?.filter((recipient) => {
    if (activeTab === 'sent') return true;
    if (activeTab === 'delivered')
      return !campaigns?.bouncedEmails?.some(
        (b) => b.email === recipient.email
      );
    if (activeTab === 'opened')
      return campaigns?.openedEmails?.some(
        (o) => o.email === recipient.email
      );
    if (activeTab === 'clicked')
      return campaigns?.clickedEmails?.some(
        (c) => c.email === recipient.email
      );
    if (activeTab === 'bounced')
      return campaigns?.bouncedEmails?.some(
        (b) => b.email === recipient.email
      );
    if (activeTab === 'unsubscribed')
      return campaigns?.unsubscribedEmails?.some(
        (u) => u.email === recipient.email
      );
    return false;
  })
  .map((recipient, index) => {
    const opened = campaigns?.openedEmails?.find(
      (o) => o.email === recipient.email
    );
    const clicked = campaigns?.clickedEmails?.find(
      (c) => c.email === recipient.email
    );
    const bounced = campaigns?.bouncedEmails?.find(
      (b) => b.email === recipient.email
    );
    const unsubscribed = campaigns?.unsubscribedEmails?.find(
      (u) => u.email === recipient.email
    );

    // Determine action text
    let actionText = 'Sent';
    if (activeTab === 'delivered') actionText = 'Delivered';
    if (activeTab === 'opened') actionText = 'Opened';
    if (activeTab === 'clicked') actionText = 'Clicked';
    if (activeTab === 'bounced') actionText = 'Bounced';
    if (activeTab === 'unsubscribed') actionText = 'Unsubscribed';

    return (
      <div className="recipient-row" key={index}>
        <div>{recipient.email}</div>
        <div>
          <div>{actionText}</div>
          {expandedEmails[recipient.email] && (
            <div className="expanded-status">
              <div>Sent</div>
              {!bounced && <div>Delivered</div>}
              {(activeTab === 'opened' ||
                activeTab === 'clicked' ||
                activeTab === 'unsubscribed') &&
                opened && <div>Opened</div>}
              {activeTab === 'clicked' && clicked && <div>Clicked</div>}
              {activeTab === 'bounced' && bounced && <div>Bounced</div>}
              {activeTab === 'unsubscribed' &&
                unsubscribed && <div>Unsubscribed</div>}
            </div>
          )}
        </div>

        {/* Date & Time */}
        <div>
          <button
            onClick={() => toggleShowDetails(recipient.email)}
            className="email-toggle-btn"
          >
            {expandedEmails[recipient.email] ? 'Hide' : 'Show'}
          </button>
          {expandedEmails[recipient.email] && (
            <div className="expanded-row">
              <div>
               
                {recipient.timestamp
                  ? new Date(campaigns.createdAt).toLocaleString('en-US', {
              month: 'short',   
              day: 'numeric',   
              hour: 'numeric',  
              minute: '2-digit', 
              hour12: true      
            })
                  : 'N/A'}
              </div>
              {!bounced && (
                <div>
                
                  {recipient.timestamp
                    ?new Date(campaigns.createdAt).toLocaleString('en-US', {
              month: 'short',   
              day: 'numeric',   
              hour: 'numeric',  
              minute: '2-digit', 
              hour12: true      
            })
                    : 'N/A'}
                </div>
              )}
              {(activeTab === 'opened' ||
                activeTab === 'clicked' ||
                activeTab === 'unsubscribed') &&
                opened && (
                 <div>
        {opened.timestamp
          ? new Date(opened.timestamp).toLocaleString('en-US', {
              month: 'short',
              day: 'numeric',
              hour: 'numeric',
              minute: '2-digit',
              hour12: true,
            })
          : 'N/A'}
      </div>
                )}
              {activeTab === 'clicked' && clicked && (
                 <div>
      {clicked.timestamp
        ? new Date(clicked.timestamp).toLocaleString('en-US', {
            month: 'short',
            day: 'numeric',
            hour: 'numeric',
            minute: '2-digit',
            hour12: true,
          })
        : 'N/A'}
    </div>
              )}
              {activeTab === 'bounced' && bounced && (
               <div>
      {bounced.timestamp
        ? new Date(bounced.timestamp).toLocaleString('en-US', {
            month: 'short',
            day: 'numeric',
            hour: 'numeric',
            minute: '2-digit',
            hour12: true,
          })
        : 'N/A'}
    </div>
              )}
              {activeTab === 'unsubscribed' && unsubscribed && (
                 <div>
      {unsubscribed.timestamp
        ? new Date(unsubscribed.timestamp).toLocaleString('en-US', {
            month: 'short',
            day: 'numeric',
            hour: 'numeric',
            minute: '2-digit',
            hour12: true,
          })
        : 'N/A'}
    </div>
              )}
            </div>
          )}
        </div>
      </div>
    );
  })}

</div>

  </div>
) : (
  <div className='campaign-details' >
                     <div className='details'>
                      <div className='detail-sub'>Subject</div>
                       <div className='detail-text'>{campaigns?.subject}</div>
                    </div>
                    <div className='details'>
                      <div className='detail-sub'>From address</div>
                       <div className='detail-text'>{campaigns?.fromEmail}</div>
                    </div>
                    <div className='details'>
                      <div className='detail-sub'>Recipient details</div>
                       <div className='detail-text-list'><PiUserListFill />{campaigns?.listName || 'N/A'} </div>
                    </div>
                    <div className='details'>
                      <div className='detail-sub'>Created on</div>
                       <div className='detail-text'>{campaigns?.createdAt ? new Date(campaigns.createdAt).toLocaleString() : 'N/A'}</div>
                    </div>
                    <div className='details'>
                      <div className='detail-sub'>Last Edited</div>
                       <div className='detail-text'>  {campaigns?.updatedAt ? new Date(campaigns.updatedAt).toLocaleString() : 'N/A'}</div>
                    </div>
                    <div className='details'>
                      <div className='detail-sub'>Email Preview</div>
                       <div className='detail-text-container'>
                         <div className='details'>
                      <div className='detail-sub2'>Subject:</div>
                       <div className='detail-text2'>{campaigns?.subject}</div>
                    </div>
                     <div className='details'>
                      <div className='detail-sub2'>Content:</div>
                       <div className='detail-text2'>{campaigns?.message?.substring(0, 50) + '...'}</div>
                    </div>
                      <div className='detail-sub3'>Show Preview <IoIosArrowDown /></div>
                       </div>
                    </div> 
                </div>
)}

                
                </div>
                 <div style={{ width: "900px", height: 300, marginTop:"20px", marginLeft:"50px" }} ref={chartRef} >
     {chartData.length > 0 && (
  <ResponsiveContainer height={300}>
    <LineChart
      data={chartData}
      margin={{ top: 20, right: 30, left: 0, bottom: 0 }}
    >
      <CartesianGrid strokeDasharray="3 3" />
      <XAxis dataKey="date" />
      <YAxis domain={[0, 100]} />
      <Tooltip />
      <Legend />
      <Line type="monotone" dataKey="openRate" stroke="#8884d8" strokeWidth={2} dot={{ r: 5 }} name="Open rate" />
      <Line type="monotone" dataKey="clickRate" stroke="#00C49F" strokeWidth={2} dot={{ r: 5 }} name="Click rate" />
      <Line type="monotone" dataKey="deliveryRate" stroke="#FFBB28" strokeWidth={2} dot={{ r: 5 }} name="Delivery rate" />
      <Line type="monotone" dataKey="bounceRate" stroke="#FF6F61" strokeWidth={2} dot={{ r: 5 }} name="Bounce rate" />
      <Line type="monotone" dataKey="unsubscribeRate" stroke="#888888" strokeWidth={2} dot={{ r: 5 }} name="Unsubscribe rate" />
    </LineChart>
  </ResponsiveContainer>
)}

    </div>
    </div>
  )
}

export default CampaignPage
